import React from "react";
import "./TableCstm.scss";
import Tooltip from "../Tooltip/Tooltip";

const TableCstm = ({
    columns,
    data,
    getRowClass,
    getRowObservation,
    onRowClick,
    className,
    positionTooltip,
    border,
    alternateRows
}) => {
    return (
        <div className="table-container">
            <table className={`${alternateRows ? 'alternate-rows ' : ''}custom-table ${className || ''}`}>
                <thead>
                    <tr>
                        {columns.map((col, index) => (
                            <th
                                key={index}
                                className={`caption ${col.headerClassName || ""}`}
                            >
                                {col.header}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {data.map((row, rowIndex) => (
                        <tr
                            key={rowIndex}
                            className={`${getRowClass ? getRowClass(row) : 'sub-color'}`}
                            onDoubleClick={() => onRowClick && onRowClick(row)}
                        >
                            {columns.map((col, colIndex) => {
                                const cellValue = row[col.accessor];

                                const cellClass = `
                                    border
                                    ${col.className || ""}
                                    ${col.cellClass ? col.cellClass(cellValue, row, col) : ""}
                                `;

                                const content = getRowObservation ? (
                                    <Tooltip text={getRowObservation(row)} position={positionTooltip}>
                                        {cellValue}
                                    </Tooltip>
                                ) : (
                                    cellValue
                                );

                                return (
                                    <td
                                        key={colIndex}
                                        className={cellClass}
                                        style={border ? { borderColor: border } : {}}
                                    >
                                        {content}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableCstm;